<div class="hubspot-dialog-container" role="dialog" aria-modal="true" [attr.aria-labelledby]="data?.title ? 'dialog-title' : null">
  <header class="dialog-header">
    <div class="title-container">
      <img src="assets/images/brand/timedoctor/logo_blue.svg" alt="TimeDoctor Logo" class="logo">
      <h2 *ngIf="data?.title" id="dialog-title">{{ data.title }}</h2>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="closeDialog()"
      aria-label="Close dialog"
      type="button">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <main class="dialog-content">
    <!-- Form container with relative positioning -->
    <div class="form-container">
      <!-- Skeleton UI positioned absolutely on top of the form -->
      <!-- Total of 7 skeleton fields (6 inputs + 1 textarea) for better visual representation -->
      <div class="form-skeleton" [class.visible]="isLoading">
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-input"></div>
        </div>
        <div class="skeleton-field">
          <div class="skeleton-label"></div>
          <div class="skeleton-textarea"></div>
        </div>
        <div class="skeleton-button"></div>
      </div>

      <!-- Actual form container -->
      <div id="hubspot-form-container" aria-live="polite"></div>
    </div>
  </main>
</div>
